import * as React from 'react';
import * as moment from 'moment';
import { IEvent } from '../../custom/classes/event';
import { ICalendarState, IMonth, IDay } from '../../classes/calendar';
import { connect } from 'react-redux';

import GridMonthView from 'grid-month.view';
import { ICalendarAppState } from '../../redux-state';
import { ICalendarAppText } from '../../custom/classes/calendar-text';


interface IGridMonthExternalProps {
    monthData: IMonth<IEvent>;
    showDaysOfWeek: boolean;
    todaysDate: moment.Moment;
}

interface StateToProps {
    text: ICalendarAppText;
}

export type GridMonthProps = IGridMonthExternalProps & StateToProps;

export class GridMonthBase extends React.Component<GridMonthProps, any> {
    render() {
        return (
            <GridMonthView {...this.props} />
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: IGridMonthExternalProps): StateToProps {
    return {
        text: state.calendarText
    }
}

export default connect<StateToProps>(mapStateToProps)(GridMonthBase);